import referenceContent from '../content/references.json'
import workExperienceContent from '../content/work-exp.json'
import npExperienceContent from '../content/np-exp.json'
import ratingContent from '../content/ratings.json'
import generalContent from '../content/general-content.json'
import { type Output, type ExperienceObject, type RatingList, type TranslationObject} from './types'

function createExperienceObject(json: unknown, formattedData: Output,experienceObject: ExperienceObject) {
  if (typeof json === 'object' && json !== null) {
    for (const [expKey, data] of Object.entries(json)) {
      //Save the data that won't be translated
      experienceObject[expKey] = {
        company: data.company,
        startTime: data.startTime,
        endTime: data.endTime,
        tags: data.tags,
      }
      //Add records for translation
      formattedData["en"].translation[expKey] = data.en
      formattedData["sv"].translation[expKey] = data.sv
      formattedData["fi"].translation[expKey] = data.fi
    }
  }
}

function createReferenceObject(json: unknown, formattedData: Output) {
  if (typeof json === 'object' && json !== null) {
    //reference formatting for i18next and rendering
    for (const [personKey, data] of Object.entries(json)) {
      referenceKeys.push(personKey) //save the reference key for rendering
      formattedData["en"].translation[personKey] = data.en
      formattedData["sv"].translation[personKey] = data.sv
      formattedData["fi"].translation[personKey] = data.fi
    }
  }
}

function isTranslation(value: unknown): value is TranslationObject {
  return (
    typeof value === "object" &&
    value !== null &&
    "en" in value &&
    typeof (value as any).en === "string"
  )
}

function createRatingObject(json: unknown, formattedData: Output) {
  if (typeof json === 'object' && json !== null) {
    //go through the categories
    for (const [cat, catData] of Object.entries(json)) {
        ratings[cat] = {}
      if (typeof catData === 'object' && catData !== null) {
        for (const [key, data] of Object.entries(catData as Record<string, unknown>)) {
          if (key === "categoryTitle" && isTranslation(data)) {
              formattedData["en"].translation[cat] = data.en
              if (data.sv) formattedData["sv"].translation[cat] = data.sv
              if (data.fi) formattedData["fi"].translation[cat] = data.fi
          } else {
            ratings[cat][key] = data
          }
        }
      }
    }
  }
}

function createGeneralObject(json: unknown, formattedData: Output) {
  if (typeof json === 'object' && json !== null) {
    //formatting for general translation strings
    for (const [key, data] of Object.entries(json)) {
      formattedData["en"].translation[key] = data.en
      formattedData["sv"].translation[key] = data.sv
      formattedData["fi"].translation[key] = data.fi
    }
  }
}

//initialize the variable for 18next translation
const formattedData: Output = {
  en: {
    translation:{}
  },
  sv: {
    translation:{}
  },
  fi: {
    translation:{}
  }
}
//initialize the variables holding the data for rendering
const referenceKeys: string[] = []
const workExperiences: ExperienceObject = {}
const npExperiences: ExperienceObject = {}
const ratings: RatingList = {}

createExperienceObject(workExperienceContent,formattedData, workExperiences)
createExperienceObject(npExperienceContent,formattedData, npExperiences)
createReferenceObject(referenceContent,formattedData)
createGeneralObject(generalContent, formattedData)
createRatingObject(ratingContent, formattedData)


export { formattedData, referenceKeys, workExperiences, npExperiences, ratings }
